import { Component, OnInit } from '@angular/core';
import { EventLogListItem } from 'src/app/models';
import { EventService } from 'src/app/services/event.service';
// import { FormsModule } from '@angular/forms';

import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-event-emitter',
  templateUrl: './event-emitter.component.html',
  styleUrls: ['./event-emitter.component.scss', './../../../app.component.scss']
})

export class EventEmitterComponent implements OnInit {

  eventName: string = '';
  eventCount: number = 1;
  executionPassword: string = '';
  isLoading: boolean = false;

  constructor(private eventService: EventService) {}

   ngOnInit(): void {
    // ...existing code...
  }

  onSubmit(): void {
    this.isLoading = true;
    
    const payload = {
      NumberOfRecord: this.eventCount,
      EventName: this.eventName,
      ExecutionPassword: this.executionPassword
    };
    
    this.eventService.reEmitEvent(payload).subscribe({
      next: (result) => {
        this.isLoading = false;
        if (result === 'Event emitted successfully') {
            alert('Event re-emitted successfully');
            this.eventName = '';
            this.eventCount = 1;
            this.executionPassword = '';
        } else if (result === 'Invalid Password') {
          alert('Invalid password. Please try again.');
        } else if (result === 'Re-emit event attempted with null model') {
          alert('Re-emit event attempted with null model');
        } else if (typeof result === 'string' && result.startsWith('Error re-emitting event log entries')) {
          alert(result);
        } else {
          alert('Unknown response: ' + result);
        }
      },
      error: (err) => {
        this.isLoading = false;
        alert('Error re-emitting event: ' + err);
      }
    });
  }
}